module.exports = __webpack_public_path__ + "static/media/DSC09085-2.c3636263.jpeg";